import { imageAdapter as baseImageAdapter } from '@apester/image';

// @apester/image's adapter factory + mediaTypePathMap only know these providers. Any other
// provider (e.g. pexels) is an absolute external-CDN URL that renders via the unsplash adapter
// (direct serve + size params). Unknown providers are mapped here so no render path hands the
// factory a type it can't construct (`new adapters[TYPE]()` -> not a constructor). Known types map
// to themselves (identity) -> existing renders are byte-identical. Mapped on a copy so credit,
// which reads the raw image.type separately, is untouched.
const FACTORY_PROVIDERS = ['giphy', 'cdn', 'unsplash', 'youtube'];

const toRenderType = type => {
  if (typeof type !== 'string' || !type) return 'unsplash';
  const lower = type.toLowerCase();
  // A VIDEO cover ships as type 'youtubeVideo' with the videoId in data.path; the youtube adapter
  // builds img.youtube.com/vi/<id>/hqdefault.jpg from it. Mapping to unsplash instead renders the
  // bare videoId as a broken thumbnail, so route it to the youtube adapter.
  if (lower === 'youtubevideo') return 'youtube';
  return FACTORY_PROVIDERS.includes(lower) ? type : 'unsplash';
};

// Drop-in wrapper for @apester/image's imageAdapter. The factory reads the provider from
// element.data.type, and the poll/quiz path also reads it (+ the url field) from element.oldModel,
// so both are mapped. toRenderType normalizes even a missing/malformed type to a known provider,
// so the factory is never handed a type it can't construct.
function imageAdapter(element, quality) {
  if (element && element.data) {
    const mapped = {
      ...element,
      data: { ...element.data, type: toRenderType(element.data.type) },
    };
    if (element.oldModel && element.oldModel.type) {
      mapped.oldModel = { ...element.oldModel, type: toRenderType(element.oldModel.type) };
    }
    return baseImageAdapter(mapped, quality);
  }
  return baseImageAdapter(element, quality);
}

export { imageAdapter, toRenderType };
